import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class BrandSignupAboutYouController extends Controller {
  @service('commands/user-commands') userCommandService;
  @service router;
  @service session;

  @task
  *updateUserInfo(userParams, userRelationships) {
    const params = { ...userParams, update_slug: true };

    yield this.userCommandService.updateUser(
      this.session.currentUser,
      params,
      userRelationships,
    );

    yield this.session.loadCurrentUser();

    yield this.router
      .refresh(EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP)
      .catch(() => {});
  }
}

export default BrandSignupAboutYouController;
